import { createApp } from 'vue'
import App from './App.vue'
import "./css/main.css"

createApp(App).mount('#app')